module.exports = __webpack_public_path__ + "static/media/entertainment.c4999ac0.svg";